import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.133.354a.375.375 0 0 0-.463.59 6.716 6.716 0 0 1 2.58 5.308c0 2.084-.941 4.02-2.582 5.31a.375.375 0 0 0 .463.59 7.461 7.461 0 0 0 2.87-5.9A7.46 7.46 0 0 0 12.133.354ZM3.337 11.566A6.715 6.715 0 0 1 .75 6.253c0-2.085.941-4.02 2.582-5.31a.375.375 0 0 0-.463-.59A7.46 7.46 0 0 0 0 6.254a7.46 7.46 0 0 0 2.873 5.903.373.373 0 0 0 .527-.063.375.375 0 0 0-.064-.527Z"
      fill="#636F7C"
    />
    <path
      d="M13.5 6.254c0-3.308-2.692-6-6-6s-6 2.692-6 6 2.692 6 6 6 6-2.692 6-6Zm-6 5.25a5.256 5.256 0 0 1-5.25-5.25 5.256 5.256 0 0 1 5.25-5.25 5.256 5.256 0 0 1 5.25 5.25 5.256 5.256 0 0 1-5.25 5.25Z"
      fill="#636F7C"
    />
    <path
      d="M9.467 7.642a.375.375 0 0 0-.524.077l-.73.98.727-3.493V5.2c.004-.015.004-.03.005-.045l.003-.03-.003-.033c-.002-.015-.003-.029-.006-.043v-.005L8.93 5.02c-.004-.014-.008-.028-.014-.04-.004-.012-.01-.022-.016-.032l-.019-.032c-.006-.01-.014-.019-.022-.028l-.024-.027-.026-.022-.03-.024-.031-.017c-.011-.005-.022-.012-.034-.016-.013-.006-.026-.009-.04-.013l-.024-.008h-.006c-.014-.003-.029-.004-.043-.005l-.032-.002-.033.003-.042.005-.005.001-2.005.463.78-3.217a.375.375 0 0 0-.728-.176L5.612 5.64a.375.375 0 0 0 .449.453l2.025-.468-.783 3.767-1.246-1.674a.375.375 0 0 0-.602.447l1.744 2.344c.003.005.008.008.012.013a.381.381 0 0 0 .104.088c.009.005.016.01.025.013a.374.374 0 0 0 .052.02l.026.008.005.001a.375.375 0 0 0 .156-.001l.019-.005a.356.356 0 0 0 .059-.021l.016-.008a.363.363 0 0 0 .065-.043l.008-.007a.377.377 0 0 0 .047-.05l.008-.008 1.743-2.344a.375.375 0 0 0-.077-.524Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent